var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElectrician2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-36"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.11,
    y: 317.98,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.34,
    y: 332.09,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.87,
    y: 246.71,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.1,
    y: 260.82,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.18,
    y: 332.09,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 427.41,
    y: 113.62,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.18,
    y: 127.73,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.33,
    y: 246.71,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.11,
    y: 113.62,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.19,104.62H295.5V46.36H427.19Zm-127.69-4H423.19V50.36H299.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.79,
    y: 49.88,
    width: 4,
    height: 51.21,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-36"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 262.25,
    cy: 453.13,
    rx: 174.67,
    ry: 16.83,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-36"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "46.98 430.13 97.74 429.88 148.49 429.8 250 429.63 351.51 429.8 402.26 429.88 453.01 430.13 402.26 430.37 351.51 430.46 250 430.63 148.49 430.46 97.74 430.37 46.98 430.13",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--fuse-box--inject-36"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.29,
    y: 71.3,
    width: 31.86,
    height: 174.76,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.16,
    y: 71.3,
    width: 82.18,
    height: 174.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.74,
    y: 74.11,
    width: 77.02,
    height: 169.2,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.26,
    y: 74.11,
    width: 24.5,
    height: 169.2,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.84 251.1 186.34 246.06 186.34 71.3 230.84 66.26 230.84 251.1",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.68,
    y: 125.97,
    width: 41.14,
    height: 48.34,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.68,
    y: 125.97,
    width: 4.7,
    height: 48.34,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.89,130a1.44,1.44,0,1,1-1.44-1.43A1.43,1.43,0,0,1,129.89,130Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.45,
    cy: 170.31,
    r: 1.44,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.36,130a1.44,1.44,0,1,1-1.44-1.43A1.43,1.43,0,0,1,158.36,130Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.36,170.31a1.44,1.44,0,1,1-1.44-1.44A1.43,1.43,0,0,1,158.36,170.31Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.71,137.71a2.35,2.35,0,1,1-2.34-2.35A2.35,2.35,0,0,1,131.71,137.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.71,145.82a2.35,2.35,0,1,1-2.34-2.35A2.34,2.34,0,0,1,131.71,145.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.94,239.17c-.8-14.76,3.7-44.61,6.68-64.36,1.36-9.06,2.44-16.22,2.54-18.8.3-7.46-4.87-9.17-5.09-9.24l.58-1.91c.07,0,6.87,2.17,6.51,11.23-.11,2.69-1.19,9.9-2.57,19-3,19.68-7.44,49.4-6.65,64Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.89,239.21c-1.08-11.08,1.75-29.28,4.47-46.88,2.92-18.79,5.93-38.22,3.53-46.23-2-6.65-7.41-7.37-7.64-7.4l.22-2c.29,0,6.95.85,9.33,8.81,2.53,8.44-.38,27.22-3.46,47.1-2.71,17.48-5.51,35.55-4.46,46.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.32,
    y: 174.31,
    width: 4.54,
    height: 69,
    style: {
      fill: "#FF9707"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.27,
    y: 74.11,
    width: 4.54,
    height: 51.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.04,
    y: 239.12,
    width: 23.14,
    height: 4.19,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.57,
    width: 10.09,
    height: 71.3,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.71,
    width: 3.34,
    height: 71.3,
    transform: "translate(292.75 71.3) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.59,
    width: 3.34,
    height: 71.3,
    transform: "translate(308.52 71.3) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.13,325.68c0,1.65-1,3-2.18,3s-2.18-1.34-2.18-3,1-3,2.18-3S139.13,324,139.13,325.68Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.71,
    y: 246.06,
    width: 3.34,
    height: 71.3,
    transform: "translate(292.75 563.42) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.71 317.36 148.05 317.36 136.56 327.02 136.56 324.31 144.71 317.36",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.09,
    y: 246.06,
    width: 5.04,
    height: 81.39,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.97,
    cy: 334.51,
    rx: 2.18,
    ry: 2.99,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.09 327.45 132.13 327.45 119.57 336.45 119.57 332.77 127.09 327.45",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.62,325.68c0,1.65-1,3-2.18,3s-2.18-1.34-2.18-3,1-3,2.18-3S146.62,324,146.62,325.68Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.59,
    y: 246.06,
    width: 3.34,
    height: 71.3,
    transform: "translate(308.52 563.42) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.59 317.36 155.93 317.36 144.44 327.02 144.44 324.31 152.59 317.36",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.43,322.79c-3.39-3.33-7.78-7.35-13-5.91-4.89,1.35-6.76,6.68-7.63,11.12-1.13,5.72-2,11.5-2.91,17.27s-1.78,11.65-2.62,17.48q-.7,4.94-1.4,9.87l-.69,4.94c-.22,1.62-.49,3.23-.58,4.86,0,.52.78.6.9.1.63-2.74.89-5.6,1.29-8.39s.81-5.6,1.22-8.41q1.23-8.34,2.5-16.69t2.59-16.69c.76-4.71,1.11-10.57,5.29-13.68a8.08,8.08,0,0,1,7.82-.74c2.75,1.05,4.94,3,7.1,5C280.4,323,280.5,322.85,280.43,322.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.79,319.39s-7-2.5-10.37,2.57.67,18,32.27,25.22a89,89,0,0,0-7.6-28.57C283.31,303.83,271.24,309.43,275.79,319.39Z",
    style: {
      fill: "#FF9707"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.88,345.07a26.13,26.13,0,0,0-1.59-2.57c-.53-.81-1.06-1.62-1.61-2.43-.4-.61-.82-1.21-1.23-1.81,0-.14,0-.3.06-.45s.07-.55.1-.82c.08-.59.17-1.18.26-1.78s.18-1.17.29-1.76a9.65,9.65,0,0,1,.42-1.86c0-.09-.13-.14-.14,0a7.74,7.74,0,0,1-.28,1.05c-.08.26-.15.53-.21.79-.16.6-.3,1.21-.44,1.81s-.23,1.12-.32,1.68c-.05.27-.09.54-.13.81-.56-.81-1.13-1.6-1.73-2.38-1.68-2.21-3.45-4.34-5.29-6.42,0,0,0,0,0,0,.17-3.32.09-6.61.82-9.88,0-.09-.11-.14-.13-.05a34,34,0,0,0-1.18,9.45l-2-2.19q-2.31-2.48-4.71-4.88c-.07-.06-.17,0-.1.1,2.66,2.87,5.19,5.85,7.65,8.89a53.09,53.09,0,0,0-5.78.22c-2.14.15-4.27.43-6.4.72-.09,0-.06.16,0,.14a62.14,62.14,0,0,1,6.39-.57c2.06-.09,4.11,0,6.17,0q2,2.47,3.95,5H287c-1,0-1.92.08-2.88.16a44.08,44.08,0,0,0-5.83.87c-.09,0-.07.16,0,.14,1.94-.21,3.88-.4,5.84-.47.93,0,1.86,0,2.79,0h1.46a1.85,1.85,0,0,0,.79-.08l2.55,3.32q1,1.32,2,2.67c.66.92,1.26,1.92,2,2.78A.07.07,0,0,0,295.88,345.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.81,326.57a21.21,21.21,0,0,0-3.38-.17c-1.13,0-2.26,0-3.38.08a.07.07,0,1,0,0,.14c1.15-.09,2.29-.11,3.44-.09s2.21.12,3.32.09C278.84,326.62,278.85,326.57,278.81,326.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.73,329.11c.13-1.07.26-2.16.49-3.22a.07.07,0,1,0-.13,0c-.17,1.06-.37,2.12-.53,3.18-.08.53-.15,1.06-.22,1.6a7.64,7.64,0,0,0-.13,1.51.1.1,0,0,0,.19,0,8.41,8.41,0,0,0,.16-1.51C288.61,330.14,288.67,329.63,288.73,329.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.65,317.15c-.28,1.06-.55,2.12-.74,3.19-.1.54-.19,1.09-.26,1.63a7.14,7.14,0,0,0-.11,1.6s.07,0,.09,0a9.45,9.45,0,0,0,.25-1.52c.07-.52.15-1.05.24-1.57.19-1.1.39-2.19.66-3.28C286.81,317.11,286.67,317.07,286.65,317.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.49,381.26q-.26-3-.57-6-.63-5.91-1.43-11.79c-.52-3.91-1-7.83-1.65-11.73a29.1,29.1,0,0,0-1.21-5.32,5,5,0,0,0-2.95-3.33c-3.72-1.29-6.23,2.57-7.73,5.3,0,.08.08.14.13.07.9-1.3,3.38-4.92,6.2-4.75,1.9.11,3.42,1.45,4.33,6.19,2.27,11.79,4.32,35.72,4.55,37.29.13.83.72.79.72-.1C245.89,385.16,245.67,383.2,245.49,381.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,347s3.25-11.48-3.93-5.74c-12,9.56-12.39,30.33-12.39,30.33s21.27-12.35,23.91-20.49C242.48,338.92,231,347,231,347Z",
    style: {
      fill: "#FF9707"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235,352.58c-1.67.34-3.36.56-5,.81l-2.39.33c-.54.08-1.08.13-1.63.2,1.59-2.19,3.18-4.36,4.7-6.59.06-.08-.07-.17-.14-.1a49.68,49.68,0,0,0-3.55,4.1c-.31-.89-.63-1.78-.94-2.66-.37-1-.75-2.05-1-3.11a.07.07,0,1,0-.13,0c.29,1,.49,2.12.77,3.18s.59,2,1,3c-.78,1-1.53,2-2.25,3.1-.37-1-.82-2-1.15-3.1,0-.08-.16,0-.13,0,.38,1.17.58,2.38.94,3.55-.49.71-1,1.43-1.44,2.15-.86,1.32-1.67,2.67-2.46,4a.33.33,0,0,0-.19.32c-1.34,2.32-2.62,4.68-3.88,7.06a.07.07,0,0,0,.13.07c1.26-2.35,2.66-4.64,4.12-6.89h0A2.91,2.91,0,0,1,221,362l.74-.15c.55-.12,1.09-.27,1.64-.4,1.08-.27,2.14-.52,3.24-.71.09,0,.05-.16,0-.14-1.29.25-2.58.39-3.88.54-.61.07-1.23.15-1.84.25h-.09c.77-1.16,1.54-2.31,2.33-3.45s1.56-2.23,2.36-3.33c.74-.11,1.47-.3,2.2-.44l2.47-.48c1.65-.33,3.28-.69,4.94-1C235.11,352.71,235.07,352.57,235,352.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.2,353.72l-.29-.92a18,18,0,0,1-.48-1.92c0-.09-.16-.05-.14,0,.14.65.29,1.29.44,1.94a13,13,0,0,0,.55,1.91.13.13,0,0,0,.25-.08C222.44,354.36,222.31,354,222.2,353.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.15,349.93c-1,.14-1.94.21-2.92.3s-1.95.22-2.92.36c-.06,0-.06.09,0,.09,1-.07,1.95-.14,2.92-.27s2-.27,2.93-.34C237.25,350.06,237.24,349.91,237.15,349.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.14,366.73c-.38-8.45-.91-16.89-1.76-25.31-.42-4.19-.9-8.38-1.49-12.55a89.61,89.61,0,0,0-2.42-12.14,23.32,23.32,0,0,0-4-8.57,9.2,9.2,0,0,0-8.17-3.57c-3.7.46-6.68,2.79-9.25,5.32-2.89,2.84-5.54,5.94-8.22,9l-2,2.32c-.06.07,0,.17.1.1,2.62-3,5.34-5.93,8.18-8.72,2.63-2.58,5.34-5.4,9-6.47a9.28,9.28,0,0,1,5.22-.12,8.29,8.29,0,0,1,3.56,2.26,18.69,18.69,0,0,1,4,7.81c2.27,7.77,3.09,15.91,3.93,23.93s1.44,16.32,1.85,24.51.73,16.46,1.52,24.66c.1,1,.23,2,.36,3,.08.68,1.14.68,1.08,0C261.91,383.7,261.52,375.22,261.14,366.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.54,310.83s4.83-8.93-.88-11.8-24.78,18.44-30.35,49.59c0,0,30.82-13.64,41.28-27.23S242.19,304.81,233.54,310.83Z",
    style: {
      fill: "#FF9707"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.07,318.09c-3.46,0-6.92-.26-10.38-.24l1.95-2.23a32.28,32.28,0,0,0,2.71-3.14c.05-.07-.06-.18-.13-.12A25,25,0,0,0,229.6,315c-.87.92-1.73,1.84-2.59,2.77q-2,2.16-3.91,4.35c0-.14,0-.28,0-.42,0-.61,0-1.21,0-1.82,0-1.17,0-2.35,0-3.52,0-2.38,0-4.78.18-7.15,0-.1-.13-.09-.14,0-.17,2.39-.41,4.77-.53,7.16-.06,1.17-.09,2.35-.1,3.53,0,.6,0,1.21,0,1.81,0,.33,0,.68,0,1l-.61.67c-2.76,3.16-5.39,6.43-8,9.76a5.07,5.07,0,0,0,0-.56c0-.36-.08-.73-.12-1.1-.09-.79-.2-1.58-.31-2.37s-.23-1.49-.36-2.23-.34-1.67-.41-2.52c0-.1-.16-.08-.13,0a21.28,21.28,0,0,1,.28,2.53c.08.76.15,1.53.22,2.29s.13,1.52.21,2.29c0,.36.07.73.11,1.1,0,.18,0,.36.07.55a.94.94,0,0,0,.15.43l-1.32,1.72c-1.75,2.32-3.46,4.65-5.18,7,0,.07.05.17.1.1,1.63-2.12,3.3-4.2,5-6.26,1.26.05,2.56,0,3.83-.06s2.67,0,4,0c.09,0,.08-.14,0-.14l-4,0c-1.22,0-2.46-.06-3.68,0,1.49-1.81,3-3.61,4.51-5.41l1.65-2a6.69,6.69,0,0,0,1.55,0h1.82c1.14,0,2.28,0,3.42,0,2.35,0,4.7-.11,7.06-.12.09,0,.08-.14,0-.14-2.35,0-4.71-.13-7.06-.19-1.14,0-2.28-.07-3.42-.08l-1.82,0c-.35,0-.71,0-1.06,0l3.89-4.6a.19.19,0,0,0,.07-.08c1.26-1.49,2.52-3,3.8-4.46l.53-.6c3.59.11,7.18-.13,10.77-.06C238.17,318.24,238.16,318.09,238.07,318.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.3,324.21h-.84a.07.07,0,0,0,0,.13h.84C236.4,324.36,236.39,324.21,236.3,324.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.44,324.22c-1.11,0-2.22,0-3.33-.07l-1.67,0a6.19,6.19,0,0,0-1.55,0s0,.09,0,.1a5.73,5.73,0,0,0,1.55.11l1.66,0h3.33C234.53,324.37,234.53,324.23,234.44,324.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.75,334.63a46,46,0,0,0-6.82-.62,0,0,0,0,0,0,.05c2.27.22,4.53.34,6.78.7C224.8,334.78,224.84,334.64,224.75,334.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.48,324.71c0-.2,0-.4-.07-.59-.06-.45-.13-.89-.2-1.34-.13-.84-.28-1.69-.44-2.53,0-.08-.15-.06-.14,0,.11.87.2,1.74.28,2.62,0,.43.07.86.11,1.29a3.61,3.61,0,0,0,.18,1.22c.06.13.26.08.29,0A1.54,1.54,0,0,0,215.48,324.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.84,299.36c-1.11-2.05-2.51-4.77-5.26-4.59-2.28.14-3.3,2.46-3.79,4.38-1.5,5.93-1.6,12.18-1.9,18.26-.61,12.85-1.17,25.71-1.25,38.57q0,5.34,0,10.7c0,3.63,0,7.29.26,10.92a.27.27,0,0,0,.53,0c0-3.1-.09-6.22-.1-9.33s0-6.07.06-9.1q.15-9.22.49-18.44c.23-6.11.5-12.21.75-18.32q.19-4.58.4-9.15c.13-3,.26-5.92.6-8.86.19-1.64.43-3.29.78-4.91a6.75,6.75,0,0,1,1.42-3.3,3.11,3.11,0,0,1,4-.29,8.63,8.63,0,0,1,2.85,3.55C260.76,299.52,260.88,299.44,260.84,299.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.09,298.38s-2.26-8,2.74-4c8.33,6.66,8.63,21.13,8.63,21.13s-14.81-8.6-16.65-14.28C252.07,292.78,260.09,298.38,260.09,298.38Z",
    style: {
      fill: "#FF9707"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.34,309.58c-.13-.22-.28-.44-.42-.66a3.86,3.86,0,0,0,0-.68c0-.34,0-.69,0-1,0-.68,0-1.35.07-2a.07.07,0,1,0-.14,0c0,.66-.06,1.32-.08,2,0,.33,0,.67,0,1,0,.13,0,.28,0,.42-.58-.9-1.17-1.79-1.79-2.67-.18-.26-.37-.5-.55-.76a15.16,15.16,0,0,1-.05-2.61c0-.93,0-1.85.06-2.78a.07.07,0,0,0-.14,0c0,1-.08,1.93-.13,2.9a20.36,20.36,0,0,0-.05,2.07c-1.43-1.95-2.95-3.82-4.49-5.69-.05-.06-.16,0-.11.09,1,1.2,1.87,2.44,2.76,3.69-1.74-.41-3.51-.64-5.29-.9-.09,0-.12.13,0,.14,1.87.28,3.71.75,5.57,1.16h0c.71,1,1.41,2,2.11,3l.84,1.23h-.08l-.58-.08-1.23-.11c-.85-.07-1.71-.11-2.56-.16-.09,0-.09.14,0,.15.84,0,1.68.08,2.52.17l1.32.16.58.07.17,0,1.42,2.1c.84,1.24,1.59,2.56,2.48,3.76.05.07.15,0,.12-.08A39.68,39.68,0,0,0,268.34,309.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.66,300.55v-.94a14.28,14.28,0,0,1,.08-2,.07.07,0,1,0-.14,0c0,.65-.07,1.29-.1,1.94,0,.32,0,.65,0,1V301a1.18,1.18,0,0,0,0,.46.06.06,0,0,0,.12,0,1.54,1.54,0,0,0,0-.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.83,303.86a15.93,15.93,0,0,0-1.68-.17c-.61-.05-1.22-.11-1.83-.19a.07.07,0,1,0,0,.14c1.17.08,2.33.29,3.5.33C262.88,304,262.89,303.87,262.83,303.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.48,303.91c0,.06,0,.23,0,.3V305c0,.19,0,.37,0,.56a1.15,1.15,0,0,0,0,.49,0,0,0,0,0,.06,0,.45.45,0,0,0,0-.23V305c0-.19,0-.37,0-.56v-.26a.8.8,0,0,1,0-.31C267.69,303.77,267.38,303.77,267.48,303.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.18,342c-3.11-2.34-5.91-5.7-10.1-5.87-3.46-.13-5.88,2.47-7.27,5.37a30.05,30.05,0,0,0-1.69,4.77q-.94,3.29-1.77,6.6c-1.08,4.34-2,8.73-2.77,13.14-.42,2.46-.81,4.93-1.12,7.4a60.38,60.38,0,0,0-.73,7.58.39.39,0,0,0,.77.09c.42-2.07.6-4.21.91-6.3s.62-4.21,1-6.31q1.06-6.28,2.48-12.52c.89-3.92,1.77-7.9,3-11.72.91-2.73,2.36-5.92,5.32-6.91,4.49-1.49,8.57,2.31,11.86,4.78C261.16,342.17,261.26,342.07,261.18,342Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258,339.78s-2.87-8.2,1.28-9.81c6.22-2.41,22.51,15.94,19.32,44,0,0-12.58-6.93-21.87-14.73s-11.68-18-7.58-20.62S258,339.78,258,339.78Z",
    style: {
      fill: "#FF9707"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.68,368a21.39,21.39,0,0,0-1.51-2.83c-.53-1-1.07-1.92-1.63-2.87-1.08-1.85-2.15-3.7-3.26-5.54l-.55-.89c0-.11,0-.22.07-.33l.19-.81c.14-.61.24-1.22.36-1.84.22-1.2.43-2.42.76-3.6,0-.09-.13-.12-.14,0-.26,1.21-.64,2.39-1,3.57-.17.57-.36,1.15-.51,1.74,0,.2-.11.4-.16.6-1.34-2.19-2.7-4.38-4.16-6.49a2.88,2.88,0,0,0,.14-.9c0-.41.09-.82.14-1.23.11-.92.22-1.85.35-2.77.27-1.81.54-3.61,1-5.39,0-.09-.12-.11-.14,0-.45,1.77-.94,3.54-1.27,5.33-.17.88-.32,1.77-.44,2.65-.06.45-.11.9-.15,1.34,0,.13,0,.27-.05.4-.46-.63-.91-1.27-1.38-1.89-1.44-1.89-2.93-3.74-4.43-5.58-.06-.07-.17,0-.12.08A99.94,99.94,0,0,1,265.86,351l1.23,2-.41,0c-.53-.07-1.06-.1-1.59-.15-1.06-.1-2.11-.2-3.17-.28-2.12-.17-4.25-.3-6.37-.52-.09,0-.11.13,0,.14,2.14.24,4.28.58,6.41.89l3.15.42a12.06,12.06,0,0,0,2.43.25l2.5,4.06a3.54,3.54,0,0,0-.56,0h-3c-1.37,0-2.73,0-4.1,0-.09,0-.08.14,0,.14,1.39,0,2.77.09,4.15.16l2,.12,1,.07a2.07,2.07,0,0,0,.86,0l2.13,3.45c.65,1.06,1.31,2.12,2,3.17a25.89,25.89,0,0,0,2.13,3.21C276.6,368.13,276.72,368.08,276.68,368Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.69,345.28a19.25,19.25,0,0,1-.57,2.67c-.23.91-.49,1.81-.79,2.7a.09.09,0,1,0,.17.06c.28-.89.53-1.78.75-2.68s.36-1.83.58-2.73A.07.07,0,1,0,270.69,345.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.44,350.77a1.07,1.07,0,0,0-.69-.26l-1.18-.16-2.22-.27c-1.53-.18-3.07-.33-4.6-.52-.09,0-.11.13,0,.14,1.44.17,2.88.39,4.33.58.7.1,1.41.2,2.12.28l1,.11a3.51,3.51,0,0,1,1.17.2C261.44,350.91,261.49,350.82,261.44,350.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.66,363.13c-.72-.06-1.45-.09-2.17-.11l-1.1,0-.53,0a3.2,3.2,0,0,1-.69,0c-.1,0-.11.16,0,.14a3.45,3.45,0,0,1,.64,0l.57,0,1.1.06c.72.05,1.45.09,2.18.09C270.75,363.28,270.75,363.14,270.66,363.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.1,360l.24-1.23c.15-.81.3-1.62.44-2.43a.07.07,0,0,0-.14,0c-.17.79-.35,1.58-.53,2.37-.09.39-.18.79-.26,1.18,0,.19-.08.37-.11.55a1.65,1.65,0,0,0-.07.58c0,.07.11.12.16,0A3,3,0,0,0,275.1,360Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.43 384.21 272.73 395.83 270.66 430.13 228.25 430.13 226.18 395.83 225.48 384.21 273.43 384.21",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.43 384.21 272.73 395.83 226.18 395.83 225.48 384.21 273.43 384.21",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.23,
    y: 375.99,
    width: 54.44,
    height: 11.63,
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.8,385.13s0,44.76,0,44.79c0,8.56-.07,16.07-.49,19.95a.13.13,0,0,1,0,.06,6,6,0,0,1-.62,2.65l-.05.05c-2.54,1.74-70.94,4.08-73.35,3.36s-.55-7.66,2-9.86,28.37-14.82,28.37-14.82l.44-44.75Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.79,420.73v9.19c0,8.56-.07,16.07-.49,19.95a.13.13,0,0,1,0,.06,11.33,11.33,0,0,1-.62,2.65l-.05.05c-2.54,1.74-70.94,4.08-73.35,3.36s-.55-7.66,2-9.86,28.37-14.82,28.37-14.82l-.12-9.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.27,456c2.42.72,70.81-1.62,73.35-3.36,1-.65,1.22-10.63,1.17-22.71,0-.12,0-.25,0-.37l-44.14,1,0,.75s-25.78,12.61-28.37,14.82S260.85,455.28,263.27,456Z",
    style: {
      fill: "#FF9707"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264,453.31c11.52-.67,58.05-2.32,69.49-2.12.09,0,.09.07,0,.08-11.4.92-57.94,2.19-69.48,2.23C263.72,453.5,263.71,453.33,264,453.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290,431.57c4.51-1,10.08-.49,13.66,2.62.14.12,0,.32-.19.27A64.22,64.22,0,0,0,290,432.14.29.29,0,0,1,290,431.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.77,433.66c4.51-1,10.08-.5,13.66,2.62.14.12,0,.31-.18.27a63.78,63.78,0,0,0-13.44-2.32A.29.29,0,0,1,286.77,433.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.56,435.74c4.51-1,10.09-.49,13.66,2.62.14.12,0,.32-.18.28a63.15,63.15,0,0,0-13.44-2.32A.3.3,0,0,1,283.56,435.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340 352.95 340 353.44 339.01 431.81 291.13 430.85 300.96 191.94 341.4 191.94 340 352.95",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.13,422.87c7.48-.07,5.33-.15,12.81-.14,3.65,0,27.69.1,31.1.7a.08.08,0,0,1,0,.15c-3.42.53-27.46,0-31.11-.05-7.48-.16-5.33-.2-12.8-.45A.11.11,0,1,1,293.13,422.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.88,396.3q.15-10.74.35-21.48.4-21.48.8-43,.78-42.74,1.37-85.47c.25-16.07.24-32.15.65-48.22,0,0,.07,0,.07,0,.26,14.32.1,28.65.08,43s-.09,28.65-.23,43q-.41,42.74-1.34,85.48c-.19,8-.39,16.07-.66,24.1s-.46,16.08-1,24.1a.1.1,0,0,1-.19,0C330.62,410.62,330.79,403.45,330.88,396.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.4 192.43 340.34 314.42 307.92 191.95 341.39 191.95 341.4 192.43",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.58,362.74s23.1,37.54,23.12,37.56c3.75,7.7,6.9,14.51,8.2,18.19a.11.11,0,0,1,0,.06,5.91,5.91,0,0,1,.59,2.65.64.64,0,0,1,0,.07c-1.54,2.67-62.15,34.44-64.64,34.84s-3.81-6.67-2.44-9.78,19.14-25.65,19.14-25.65L374.85,383Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.51,421.21a.07.07,0,0,1,0,.06c-1.53,2.67-62.15,34.44-64.64,34.84s-3.81-6.67-2.45-9.78,19.15-25.66,19.15-25.66l-4.05-6.73c9.91-5.28,27.92-14.55,39.1-20.3,2.43,3.95,4.09,6.66,4.09,6.67,3.76,7.69,6.91,14.5,8.21,18.17a.19.19,0,0,1,0,.07A5.78,5.78,0,0,1,445.51,421.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.85,456.11c2.49-.4,63.1-32.17,64.64-34.84.6-1-3.51-10.11-8.8-21a3.59,3.59,0,0,0-.17-.34l-39.33,20,.36.66s-17.76,22.54-19.14,25.66S378.36,456.51,380.85,456.11Z",
    style: {
      fill: "#FF9707"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.3,453.4c10.09-5.61,51.3-27.27,61.7-32,.08,0,.11,0,0,.06-9.88,5.78-51.26,27.1-61.64,32.15C380.17,453.67,380.09,453.52,380.3,453.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.33,422.52c3.63-2.86,8.87-4.82,13.44-3.56.18.05.11.3,0,.32A63.89,63.89,0,0,0,394.61,423,.29.29,0,0,1,394.33,422.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.34,425.79c3.63-2.86,8.87-4.82,13.44-3.56.18,0,.11.3,0,.32a63.71,63.71,0,0,0-13.11,3.74A.29.29,0,0,1,392.34,425.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.36,429.06c3.62-2.86,8.87-4.82,13.44-3.56.18.05.11.3-.05.32a63.89,63.89,0,0,0-13.11,3.74A.29.29,0,0,1,390.36,429.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.64,191.91v0c.17.83,3,14,5.93,25.22,2.13,8.23,4.33,15.46,5.58,16.21,1.43.84,8.37,3.92,10.7,4.89,0,0,15.62,78,23.86,102.12,7.61,22.31,39.09,81.93,39.09,81.93l45.67-23.07s-35.67-60.51-39.42-71.37c-5.81-16.83-27.6-99-27.6-99s.17-25.73-8.49-37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.48,413.42c6.52-3.65,4.6-2.69,11.17-6.27,3.21-1.75,24.34-13.22,27.62-14.32.07,0,.13.09.07.13-2.75,2.11-24.07,13.21-27.32,14.89-6.63,3.45-4.77,2.39-11.44,5.76A.11.11,0,0,1,393.48,413.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.75,221.71c-1.25-.32-2.59-.42-3.87-.62-1-.17-2.05-.35-3.07-.57a13.42,13.42,0,0,1-5.43-2.29c-1.77-1.37-2.66-3.46-3.52-5.46-.51-1.19-1-2.38-1.56-3.56l-.78-1.71a20.15,20.15,0,0,1-1-2.05c0-.11-.19,0-.15,0a12.54,12.54,0,0,1,.43,1.48c.18.58.34,1.15.52,1.72.32,1,.62,2.05,1,3.07a24.67,24.67,0,0,0,2.18,5.38c1.88,3,5.25,4.21,8.62,4.63,1,.13,1.94.19,2.92.25a20.56,20.56,0,0,0,3.68,0A.17.17,0,0,0,359.75,221.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.47,231.54a91.19,91.19,0,0,1,14.31,6.67c.18.1.06.38-.13.29-4.82-2.07-9.74-4.05-14.44-6.38A.32.32,0,0,1,315.47,231.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,198.51c0-.16.3-.2.3,0a161.29,161.29,0,0,0,.81,16.11c.22,2.48,2.22,16.21,6.53,15.21.72-.17,1.09-.88,1.2-2a17.34,17.34,0,0,0-.57-4.21c-.48-2.88-.86-5.76-1.11-8.66a78.7,78.7,0,0,1,.18-16.24.14.14,0,0,1,.27,0,149.9,149.9,0,0,0,1.31,22.41c.54,3.57,2.34,9-1.39,9.5s-6.27-8.45-6.73-10.91A81.73,81.73,0,0,1,314,198.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.54,230.18a22.11,22.11,0,0,1,1,2.84,6.52,6.52,0,0,1,.41,2.34.17.17,0,0,1-.3.07,8,8,0,0,1-1-2.28c-.33-.88-.68-1.75-1-2.64A.48.48,0,0,1,321.54,230.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.15,391.67c-6.5-12.24-13.2-24.37-19.93-36.48-3.32-6-6.78-11.88-9.94-17.93a108.73,108.73,0,0,1-7.23-18.7q-6-19.6-11.42-39.4T367.5,239.4c-.8-3.32-1.67-6.65-2.31-10a30.93,30.93,0,0,1,0-10.25,32.87,32.87,0,0,0,.07-9.55,62.26,62.26,0,0,0-2.23-9.32c-.5-1.61-1.05-3.21-1.6-4.8a.15.15,0,0,0-.28.09c2,6.44,4,12.95,3.56,19.78-.21,3.28-1.08,6.5-1,9.8a46.92,46.92,0,0,0,1.66,9.68q4.65,20.09,10,40t11.31,39.64c1.94,6.39,3.75,12.89,6.5,19s6.24,11.89,9.53,17.73c6.78,12.07,13.62,24.11,20.62,36.06.88,1.51,1.78,3,2.67,4.53C426.06,391.86,426.2,391.77,426.15,391.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.87,130.33C321.45,136.6,289.56,163,271.23,162c-17.16-1-36.31-37.84-41.59-44.91-2.32-3.11,23.61-21.62,26.74-18.91s16.84,32.28,19.79,33.22,27-4.68,41.57-8.32C330.92,119.75,336.7,121.69,327.87,130.33Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.5,129.26l10.6,24.18s20.63-12.09,28.41-20.67,7.26-13-8.57-10.8A175.05,175.05,0,0,0,288.5,129.26Z",
    style: {
      fill: "#FF9707"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.23 129.52 291.13 127.36 301.94 152.88 296.39 155.74 285.23 129.52",
    style: {
      fill: "#FF9707"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.23 129.52 291.13 127.36 301.94 152.88 296.39 155.74 285.23 129.52",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.75,112c-3.42-16.9-15.91-31.4-18.54-33.38-2.24-1.69-3.41-2.54-3.41-2.54-4-3.12-6.91-2.59-6.91-2.59s-3.51-4.95-6.86-3.32c-3.76,1.81,1.92,8.41,2.82,14,2.07,12.69,1.46,31.3,1.69,35Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.36,95.89a81.21,81.21,0,0,0-2.44-11,83.12,83.12,0,0,0-5.07-11.27.1.1,0,0,1,.18-.1,43.88,43.88,0,0,1,7.66,22.33A.17.17,0,0,1,241.36,95.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.2,95.76c-.86-3.59-2.42-9.88-8.51-19.62,0,0,0-.07.06,0a39.36,39.36,0,0,1,8.81,19.56C249.59,95.89,249.26,96,249.2,95.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.37,99.56c-.38,1.76-1.31,1.57-2.7-1.31s-4.47-15.47-8.77-14,.29,19.14,3,23.76,8.66,11.15,8.66,11.15C231.34,115.51,231.68,106.68,231.37,99.56Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,202.59c1.13,1.12,65.18-2.24,65.52-2.68.9-1.22-19.58-68.36-35.77-80-3.48-2.5-13.65-.18-16,2.23-1.51,1.51-4.57,11.14-6.71,19C303.71,157,300.05,201.61,301,202.59Z",
    style: {
      fill: "#FF9707"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.75,203.14s-.37-32.8,5.7-58.74c4.36-18.6,6.55-21.53,6.55-21.53l1.72-.72-3.13,15.28,13-.62s5.52-16.33,6.37-16.73c.54-.25,2.73,1.93,2.73,1.93s-5,17.32-4.32,24.39,5.65,18.12,9.81,21.45,18.35.32,18.68.4,10,33.26,10.16,33.71S300.75,203.14,300.75,203.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.29,153.66A22,22,0,0,0,317.1,157c1.54.11,8.68-2.31,9.73-2.95.53-.32-.22-11.14-.47-11.81s-16.39-.49-16.83,0C308.55,143.54,308.78,153.22,309.29,153.66Zm.62-10.72c.52-.47,14.86-.95,16-.14.16,2.24.52,10.54.29,10.82s-7.67,2.9-9,2.73c-2-.24-6.59-2.47-7.37-3C309.27,152.89,309.55,143.27,309.91,142.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.5,202.12c.38.37,2.82,23.17,1.37,24.08s-21.06,4-22.48,3.24-2.94-23.55-2.81-23.85S366.8,201.42,367.5,202.12Z",
    style: {
      fill: "#FF9707"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.26,215.75c.55,6.31,1.35,13.29,2.13,13.7,1.43.75,21-2.34,22.48-3.25.8-.5.42-7.51-.14-13.84a99.05,99.05,0,0,0-1.23-10.24c-.7-.71-23.79,3.18-23.92,3.47C343.52,205.73,343.81,210.5,344.26,215.75Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.92,201.42c.33-.3-1.83-8.81-3.12-10.95,0,0-21.06,3.69-39,5-13.42,1-28.72.27-28.8.65s-.69,9.5-.38,10.25,20.63,1,32.19.39S368.82,202.44,369.92,201.42Z",
    style: {
      fill: "#FF9707"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,207.41c.42.31,15,.5,15.29.18s.4-11.59-.74-12.25c-.68-.39-13.55-.29-14.37.08S308.6,207.09,309,207.41Zm1.57-10.64c.67-.29,11.11-.35,11.66-.05.92.51.83,9.22.61,9.46s-12.06.09-12.4-.16S309.94,197.06,310.6,196.77Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.54,
    y: 200.62,
    width: 4.09,
    height: 1.56,
    transform: "translate(622.37 404.01) rotate(-179.78)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.1,201.28a.6.6,0,0,0,1.19,0,.6.6,0,0,0-1.19,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.31,200.87a.59.59,0,0,0,.57.62.6.6,0,0,0,.62-.58.59.59,0,0,0-.58-.61A.59.59,0,0,0,334.31,200.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.71,177.56H365a0,0,0,0,1,0,0v18.57a2.5,2.5,0,0,1-2.5,2.5h-2.26a2.5,2.5,0,0,1-2.5-2.5V177.56a0,0,0,0,1,0,0Z",
    transform: "translate(741.53 334.41) rotate(173.55)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.19,
    y: 198.56,
    width: 4.9,
    height: 1.94,
    transform: "translate(745.39 357.07) rotate(173.55)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.14,
    y: 200.43,
    width: 1.55,
    height: 20.9,
    transform: "translate(749.22 379.56) rotate(173.55)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.74,223.26s1.31,3.09,1.41,3.08l.51-.06h0l.51-.06c.11,0,.69-3.31.69-3.31l-1-1.73-1.53.17Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.04,
    y: 180.03,
    width: 1.27,
    height: 16.28,
    transform: "translate(746.18 334.31) rotate(173.55)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.7,
    y: 180.3,
    width: 1.27,
    height: 16.28,
    transform: "translate(741.55 335.1) rotate(173.55)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.36,
    y: 180.56,
    width: 1.27,
    height: 16.28,
    transform: "translate(736.9 335.92) rotate(173.56)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.96,
    y: 184.37,
    width: 4.2,
    height: 6.55,
    transform: "matrix(-0.99, 0.13, -0.13, -0.99, 737.33, 327.53)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.81,186.6,353,187c-.43.05-2.34-1.67-3.66-1.5l-1.45.19c-1.25.16-6.37,2.13-5.94,5.4l.25,1.94s.5-1.81,1.65-2.29a2.24,2.24,0,0,1,2.9,1.17,21.83,21.83,0,0,1,.9,2.87l5.16-.68a20.13,20.13,0,0,1,.59-3.47c.36-.88,2.8-1,2.8-1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.39,
    y: 194.36,
    width: 3.23,
    height: 11.68,
    transform: "translate(724.92 353.44) rotate(172.59)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.33,
    y: 200.47,
    width: 4.82,
    height: 25.99,
    transform: "translate(730.07 379.65) rotate(172.59)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.26,215.75c.55,6.31,1.35,13.29,2.13,13.7,1.43.75,21-2.34,22.48-3.25.8-.5.42-7.51-.14-13.84Z",
    style: {
      fill: "#FF9707"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.85,131.07c3.88.5,9.78-6,11.86-10.93.14-.35-.71-3.69-1.55-7.79-.5-2.5-1-5.29-1.27-7.87l-15.76,5.63a41.17,41.17,0,0,1,2.6,9.73,4.78,4.78,0,0,1,0,1.07,1.07,1.07,0,0,0,0,.18C314.61,123.14,315.09,130.59,318.85,131.07Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.14,104.75C327,108,325.74,119.81,316.4,121a12.42,12.42,0,0,1-1.67.09.56.56,0,0,1,0-.19,6.25,6.25,0,0,0,0-1.06,41.48,41.48,0,0,0-2.61-9.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.86,85.94c2.48,5.49,1.58,22.4-2,26.6-5.21,6.1-14.79,7.85-20.24,1.34-5.28-6.3-3.72-28.32.4-32.24C311.06,75.85,323.2,77.82,326.86,85.94Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.23,112.33s0,0,0,0",
    style: {
      fill: "none",
      stroke: "#eb9481",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.75,98.07s.08.06.08.1c-.09,1.14,0,2.46,1,2.89,0,0,0,.07,0,.06C312.58,100.88,312.48,99.13,312.75,98.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.82,96.93c1.84-.05,1.81,3.63.1,3.68S312.28,97,313.82,96.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.19,98s-.09.06-.09.1c0,1.14-.14,2.45-1.17,2.82,0,0,0,.07,0,.07C306.19,100.86,306.39,99.12,306.19,98Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.18,96.84c-1.83-.15-2,3.52-.31,3.67S306.72,97,305.18,96.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.29,95.26a14.17,14.17,0,0,1-1.42-.52,2.43,2.43,0,0,1-1.35-.8.77.77,0,0,1,.13-.94,1.94,1.94,0,0,1,2-.18,2.8,2.8,0,0,1,1.62,1.24A.83.83,0,0,1,315.29,95.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.77,95a15,15,0,0,0,1.47-.37,2.41,2.41,0,0,0,1.42-.66.78.78,0,0,0,0-1,1.93,1.93,0,0,0-1.92-.38A2.83,2.83,0,0,0,303,93.69.83.83,0,0,0,303.77,95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.79,108.68c-.27.27-.55.63-1,.66a3,3,0,0,1-1.23-.3s-.07,0-.05.06a1.55,1.55,0,0,0,1.45.63,1.21,1.21,0,0,0,.9-1C313.92,108.67,313.83,108.64,313.79,108.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.63,105.26A3.9,3.9,0,0,1,310,107a4.69,4.69,0,0,1-1.4.05,1.09,1.09,0,0,1-.26,0l-.25,0a.28.28,0,0,1-.23-.26h0a.53.53,0,0,1,0-.12h0v-.1c0-.88.09-2.22.09-2.22-.33.16-2,.88-1.94.42a57.72,57.72,0,0,1,1.62-11.73.1.1,0,0,1,.2,0c-.1,3.66-.85,7.27-1,10.94a7,7,0,0,1,1.84-.54c.12,0-.24,2.58-.2,3a.1.1,0,0,0,0,0,5.38,5.38,0,0,0,4-1.21C312.61,105.09,312.7,105.17,312.63,105.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.27,106.77A4.55,4.55,0,0,0,311.2,108a2.06,2.06,0,0,0,1.25,0c.88-.31.84-1.13.62-1.83a4.92,4.92,0,0,0-.49-1A5.88,5.88,0,0,1,309.27,106.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.2,108a2.06,2.06,0,0,0,1.25,0c.88-.31.84-1.13.62-1.83A2.13,2.13,0,0,0,311.2,108Z",
    style: {
      fill: "#f291b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.26,88.31s0,0,0-.06l0,.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.59,98.72c-3.32,1-6.69-13.33-6.69-13.33a21.85,21.85,0,0,1-5.65,3.55,30.28,30.28,0,0,1-6.59,1.53c-.5,0,4.62-3.9,4.62-3.9s-5.5,3.63-10.25,3c-1.47-.21.91-12.51,11.27-13.5,7-.68,11,4.91,11,4.91s4.76,3.22,5.26,5.59C330.2,89.7,330.1,97.72,326.59,98.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.93,99.44s3.16-5.76,5.74-4.68.59,9.14-2.15,10.5a2.91,2.91,0,0,1-4-1.13Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,97.05a0,0,0,0,1,0,.08c-1.91,1-2.76,3-3.29,5a1.61,1.61,0,0,1,2.35-.7c.05,0,0,.12,0,.11a1.8,1.8,0,0,0-1.9.84,8.34,8.34,0,0,0-.77,1.69c-.07.19-.41.13-.36-.09v0C324.73,101.39,326.33,97.61,329,97.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.65,87.56s2.91-17.14,18.22-14.66,12.66,19.66,12.66,19.66Z",
    style: {
      fill: "#FF9707"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.28,
    y: 88.83,
    width: 33.61,
    height: 2.46,
    transform: "translate(18.47 -49.4) rotate(9.2)",
    style: {
      fill: "#FF9707"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.04 88.8 309.13 87.68 313.48 71.12 320.39 72.24 316.04 88.8",
    style: {
      fill: "#FF9707"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.04 88.8 309.13 87.68 313.48 71.12 320.39 72.24 316.04 88.8",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.72,120.38l3.92,9.44,11.65-12.14,3.39,3.81s-11.31,19.21-11.39,18.35l-4-8.13-5.58,5.75.29-14.29Z",
    style: {
      fill: "#FF9707"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.45,130.39c.12-2.36.19-4.73.42-7.08,0-.09.14-.13.16,0,.5,2.27,0,11.29,0,13.45l0,0c.23-.25,5.17-5.07,5.22-5,.86,1.29,3.8,7.21,4,7.75,1.78-3.05,8.65-14.15,10.77-17a.08.08,0,0,1,.14.08c-1.57,3.22-10.65,18.16-10.79,18.12a90.25,90.25,0,0,1-4.19-8.6c-.83,1-5.81,6.48-5.84,6.13A74.4,74.4,0,0,1,312.45,130.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.06,198.44A12.51,12.51,0,0,1,239,208l2.08-10L236,194.91l-5.86.81-2.08,10a12.52,12.52,0,1,1,20-7.32Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.81,127.32a12.53,12.53,0,0,1,9.07-9.56l-2.08,10,5.06,3.07,5.86-.81,2.08-10a12.52,12.52,0,1,1-20,7.31Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.2,
    y: 134.06,
    width: 11.15,
    height: 56.28,
    transform: "translate(31.9 -39.74) rotate(10.01)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.69,142.33c-2.81,8.52-12.3,40.35-28.94,48.11-15.58,7.26-43.62-1.77-52.26-3.84-3.77-.91.76-26.29,4.4-28.25s33.19,6.37,36.23,5.79,17.85-15.82,27.87-27C335.45,126.61,343.93,126.4,338.69,142.33Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.23,191.76c-.43-7.84-1.93-15.38-4.46-21a23.07,23.07,0,0,0-3.22-5.34,11.74,11.74,0,0,0-1.16-1.27c-.14-.13-.29-.27-.44-.39a5.86,5.86,0,0,0-.63-.51,9,9,0,0,0-3.8-1.75,5.58,5.58,0,0,0-.59-.09l-.49,0h-.66a1.58,1.58,0,0,0-.31,0,.82.82,0,0,0-.27,0,10.7,10.7,0,0,0-3.43.76l1.7.37h.09l.08,0,.12,0a9.43,9.43,0,0,1,1.44-.2h0s0,0,0,0h.82l.54,0h0a7.88,7.88,0,0,1,3.78,1.53c4.94,3.52,9.13,13,9.83,28.1.07,1.44.1,2.94.1,4.49,0,8.45-1.23,16.24-3.45,21.93-1.67,4.25-4.68,9.3-9.7,9.61h-.83l-.24,0h-.46a.35.35,0,0,1-.11,0c-7.46-1.22-14.81-14.38-14.81-35.69,0-.4,0-.81,0-1.2l-1-.21c0,.47,0,.94,0,1.41,0,10.6,2.18,21.41,6.12,28.55a24.11,24.11,0,0,0,2.57,3.81s0,0,0,0a15.36,15.36,0,0,0,1.09,1.17c.17.17.35.34.52.49a10.26,10.26,0,0,0,5.43,2.68l.23,0,.31,0h1.17a8.89,8.89,0,0,0,4.71-1.7c.19-.13.37-.27.56-.42a14.6,14.6,0,0,0,1.16-1.09,19.92,19.92,0,0,0,3.53-5.49c.23-.5.45-1,.66-1.55,2.27-5.81,3.52-13.73,3.52-22.3C306.36,194.92,306.32,193.33,306.23,191.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.77,191.25c-.54-8-2.32-15.67-5.29-21.24a0,0,0,0,0,0,0,21.47,21.47,0,0,0-3.76-5.18c-.23-.23-.46-.45-.7-.65s-.34-.28-.5-.41a10.7,10.7,0,0,0-5-2.24,5.58,5.58,0,0,0-.59-.09l-.49,0h-.66a1.58,1.58,0,0,0-.31,0,.82.82,0,0,0-.27,0,2.41,2.41,0,0,0-.38,0h-.12a12.54,12.54,0,0,0-3.24.68l.31.06,1.7.37h.09l.08,0a10.43,10.43,0,0,1,1.14-.15h.12a1.51,1.51,0,0,1,.3,0h0s0,0,0,0h.82l.54,0h0A9.48,9.48,0,0,1,296,164a18.22,18.22,0,0,1,5.75,6.75c2.63,4.87,4.53,11.84,5,20.82.09,1.58.14,3.22.14,4.93,0,8.44-1.36,16.22-3.84,21.91-.27.64-.58,1.29-.93,1.94-1.93,3.63-5,7.24-9.52,7.66l-.45,0h-.83l-.24,0H291l-.2,0h-.07a8.67,8.67,0,0,1-1.44-.25.13.13,0,0,1-.08,0c-.28-.08-.55-.16-.82-.26s-.37-.13-.56-.21a16.19,16.19,0,0,1-6.91-6.45,32.14,32.14,0,0,1-2.16-4c-3-6.67-4.78-15.61-4.78-24.54,0-.53,0-1.06,0-1.58l-1-.21c0,.59,0,1.19,0,1.79,0,9.72,2,19.62,5.74,26.7a27.45,27.45,0,0,0,3.17,4.83,15.73,15.73,0,0,0,1.29,1.4,12.7,12.7,0,0,0,6.83,3.73h0l.08,0h.13l.22,0,.23,0,.38,0h1.17a10.56,10.56,0,0,0,5.91-2.14,10,10,0,0,0,1.08-.91,18.09,18.09,0,0,0,3.47-4.48,27.37,27.37,0,0,0,1.35-2.71c2.53-5.81,3.92-13.74,3.92-22.31C308,194.75,307.89,193,307.77,191.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.42,190.59c-.66-7.84-2.62-15.3-5.84-20.73a21.68,21.68,0,0,0-3.91-4.92,14.41,14.41,0,0,0-1.12-.95,12.31,12.31,0,0,0-6.62-2.58l-.37,0h-.78a1.58,1.58,0,0,0-.31,0,.82.82,0,0,0-.27,0,2.41,2.41,0,0,0-.38,0h-.12l-.89.08h-.14a14.12,14.12,0,0,0-2.44.53l.23.05.31.06,1.7.37h.09l.51-.08.51,0h.32a1.51,1.51,0,0,1,.3,0h0s0,0,0,0h.82a3.25,3.25,0,0,1,.54,0h0a11.13,11.13,0,0,1,5.09,1.71h0a14.25,14.25,0,0,1,1.8,1.32,20.11,20.11,0,0,1,3.92,4.56,0,0,0,0,1,0,0c3.08,4.79,5.35,11.81,6,21,.13,1.76.2,3.61.2,5.53,0,8.43-1.5,16.21-4.22,21.9a24.84,24.84,0,0,1-1.77,3.12,16.68,16.68,0,0,1-4,4.32,11,11,0,0,1-6,2.17l-.45,0h-.83l-.24,0h-.45l-.16,0-.18,0-.25,0a.86.86,0,0,1-.27,0,8.94,8.94,0,0,1-1.48-.38c-.19-.06-.37-.13-.56-.21a14.84,14.84,0,0,1-4.32-2.62s0,0,0,0a23.47,23.47,0,0,1-4.77-5.66c-3.84-6.16-6.45-15.25-6.45-26.7q0-1,0-2l-1-.23c0,.72,0,1.45,0,2.18,0,9.17,2,18.5,5.63,25.47a28.87,28.87,0,0,0,3.49,5.31,15.86,15.86,0,0,0,9.16,5.81l.19,0,.27,0,.12,0h.13l.22,0,.23,0h.07l.31,0h1.34a12.6,12.6,0,0,0,7.94-3.26s0,0,0,0a19.89,19.89,0,0,0,3.71-4.54.05.05,0,0,0,0,0c.44-.74.87-1.52,1.27-2.36,2.78-5.82,4.32-13.75,4.32-22.33C309.67,194.53,309.59,192.55,309.42,190.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,189.78c-.76-7.34-2.78-14.29-6-19.48l-.05-.07a20.81,20.81,0,0,0-6-6.46,14.27,14.27,0,0,0-7.33-2.4h-.87a1.58,1.58,0,0,0-.31,0,.82.82,0,0,0-.27,0,2.41,2.41,0,0,0-.38,0h-.07l-.28,0-.66.07h-.14a17.31,17.31,0,0,0-2.62.49l.18,0,.23.05.31.06,1.7.37h0l.52-.07h.05l.51,0h.32a1.51,1.51,0,0,1,.3,0h0s0,0,0,0h1.34a12.81,12.81,0,0,1,5.33,1.39,8.14,8.14,0,0,1,.77.41,10.33,10.33,0,0,1,1,.63,19.16,19.16,0,0,1,4.87,5.06c3.56,5.21,5.74,12.61,6.5,20.42q.3,3.09.3,6.23c0,8.43-1.63,16.2-4.59,21.88a23,23,0,0,1-1.71,2.81.05.05,0,0,1,0,0,17.23,17.23,0,0,1-4.85,4.77,12.9,12.9,0,0,1-1.72.93,13.15,13.15,0,0,1-4.12,1.07,4.87,4.87,0,0,1-.66,0,3.62,3.62,0,0,1-.47,0h-.36c-.24,0-.47,0-.71,0h-.64l-.18,0-.25,0a.86.86,0,0,1-.27,0l-.21,0-.37-.07a.13.13,0,0,1-.08,0,15.38,15.38,0,0,1-4.61-1.92,18.49,18.49,0,0,1-2.71-2,25.45,25.45,0,0,1-5-6.06c-3.77-6.11-6.26-14.76-6.26-25.47,0-.78,0-1.55,0-2.32l-1-.23q-.06,1.26-.06,2.55c0,8.69,1.94,17.52,5.52,24.36,3.24,6.24,7.87,10.8,13.61,12.09a6.18,6.18,0,0,0,.62.12l.13,0h0l.19,0,.27,0,.12,0h.13l.22,0h.07l.23,0,.65,0h1.22c5.16-.19,9.55-3,12.83-8.08.43-.67.84-1.37,1.23-2.12,3-5.83,4.71-13.76,4.71-22.35A65.51,65.51,0,0,0,311,189.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.58,188.85c-1.41-11-5.88-21-13.24-25.29a16,16,0,0,0-7.69-2.19h-.87a1.58,1.58,0,0,0-.31,0,.82.82,0,0,0-.27,0,2.41,2.41,0,0,0-.38,0h-.35l-.66.07h-.14a22.37,22.37,0,0,0-2.76.45l.14,0,.18,0,.23.05.31.06,1.7.37.55-.06h.05l.51,0h.32a1.51,1.51,0,0,1,.3,0h0l.31,0h1.07a14.79,14.79,0,0,1,4.7.88,11,11,0,0,1,1.19.49q.38.16.75.36h0a15.25,15.25,0,0,1,1.4.84,20.25,20.25,0,0,1,5.32,5.29l.05.07c3.52,5,5.74,11.84,6.61,19.12a59.58,59.58,0,0,1,.42,7.09c0,8.42-1.76,16.19-4.95,21.87a23.21,23.21,0,0,1-1.68,2.6,18,18,0,0,1-5.09,4.8s0,0,0,0a13.8,13.8,0,0,1-2.2,1.12,10.13,10.13,0,0,1-1.2.44,14,14,0,0,1-3.56.65,4.87,4.87,0,0,1-.66,0,3.62,3.62,0,0,1-.47,0h-.36c-.24,0-.47,0-.71,0l-.3,0h-.09l-.21,0h-.22l-.25,0a1.28,1.28,0,0,1-.27,0l-.21,0-.37-.07a.13.13,0,0,1-.08,0,16.48,16.48,0,0,1-4.09-1.43,18.16,18.16,0,0,1-1.94-1.11,20.41,20.41,0,0,1-2.79-2.15,28,28,0,0,1-5.23-6.42c-3.66-6-6.05-14.29-6.05-24.36,0-.9,0-1.8.07-2.68l-1-.24c0,1-.08,1.94-.08,2.92,0,16.64,7.65,33.8,20.66,36.45a6.18,6.18,0,0,0,.62.12l.13,0h0l.19,0,.27,0h0l.08,0h.13l.29,0,1,.07h1.07c6.39-.12,11.7-3.65,15.38-10.19,3.28-5.83,5.08-13.77,5.08-22.36A59.12,59.12,0,0,0,312.58,188.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,156.86a35.12,35.12,0,0,0-14.62,3.54l-.08,0q-1.06.54-2.07,1.17l-.23,0-1.08-.24a34.39,34.39,0,0,1,18-5.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.1,158.91a30.94,30.94,0,0,0-11.54,3l-1.32-.29-.23,0c.73-.4,1.5-.77,2.3-1.12l.08,0A32.89,32.89,0,0,1,297,157.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.49,155.74a32.74,32.74,0,0,0-13.78,5.52L281.4,161a33.6,33.6,0,0,1,14.93-6.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.21,143.39a4.75,4.75,0,0,0-.69,5.37,7,7,0,0,0-4,2.65c-1.61,2.41,1.46,6,1.46,6a8.7,8.7,0,0,0-3.75,3.47c-1.31,2.46,1.27,6.51,1.27,6.51a7.63,7.63,0,0,0-1.38,5.13c.65,4.84,7.45,7.91,11.74,9.91s18.37,3.64,21,4.23L271,159.16s-16.72-14.44-22.11-16.08C244.31,141.71,234.8,140.74,232.21,143.39Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.92,148.41c5.18.3,10,2.12,14.88,3.66a.09.09,0,0,1-.06.17c-4.85-1.59-10-2.2-14.86-3.59A.12.12,0,0,1,231.92,148.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.26,157.08a13.07,13.07,0,0,1,3.39,1c1.18.43,2.34.89,3.5,1.36,2.32.95,4.62,1.95,6.89,3,.1,0,.06.21,0,.17-2.32-.94-4.65-1.85-7-2.69-1.18-.42-2.36-.84-3.54-1.24a16.18,16.18,0,0,1-3.3-1.3A.18.18,0,0,1,229.26,157.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.62,167.41a9.5,9.5,0,0,1,3,1.06c1.05.46,2.1.9,3.15,1.35,2.11.88,4.22,1.77,6.35,2.58.11,0,.06.21,0,.17-2.18-.82-4.36-1.6-6.53-2.43l-3.19-1.25a8.67,8.67,0,0,1-2.79-1.38S226.57,167.41,226.62,167.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.25,160.63a85.53,85.53,0,0,0-9.94-2.16,74.7,74.7,0,0,0-9.22-8A80.59,80.59,0,0,0,250.91,144c-.09,0-.16.08-.08.14,3.37,2.21,6.65,4.62,9.85,7.09s6.13,5.11,9.14,7.74c.12.09,8.14,1.28,10.38,1.83C280.29,160.83,280.34,160.66,280.25,160.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.18,152.39l22,14.55s6.78-15.59,8.65-27-.93-14.82-13.06-4.41S309.18,152.39,309.18,152.39Z",
    style: {
      fill: "#FF9707"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.65 154.36 310.52 149.42 333.17 165.39 329.96 170.75 306.65 154.36",
    style: {
      fill: "#FF9707"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.65 154.36 310.52 149.42 333.17 165.39 329.96 170.75 306.65 154.36",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.39,148.82a.08.08,0,0,0-.14-.07,76.13,76.13,0,0,0-3.89,7.9c-.56,1.33-1.1,2.67-1.62,4s-.95,2.75-1.46,4.11c0,.07.09.12.12,0,.55-1.33,1.19-2.61,1.77-3.92.45-1,.9-2.05,1.36-3.08a15.88,15.88,0,0,0,2.52-4.11s0-.07-.07,0c-.45.7-.86,1.45-1.31,2.16-.27.42-.53.83-.81,1.24l.09-.21Q337.75,152.88,339.39,148.82Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tool-box--inject-36"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.46,
    y: 410.56,
    width: 106.31,
    height: 43.12,
    style: {
      fill: "#FF9707"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.78,
    y: 398.87,
    width: 115.69,
    height: 11.69,
    style: {
      fill: "#FF9707"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.46,
    y: 410.56,
    width: 106.32,
    height: 8.23,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.74,
    y: 406.11,
    width: 23.24,
    height: 8.92,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.34 398.87 166.83 398.87 166.83 391.89 136.41 391.89 136.41 398.87 130.9 398.87 130.9 386.38 172.34 386.38 172.34 398.87",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectrician2);
export default __webpack_public_path__ + "static/media/Electrician2.7a4df51d07561e223d4fa4727d1d4b97.svg";
export { ForwardRef as ReactComponent };